module.exports = __webpack_public_path__ + "img/logoTextSTC.3ac9d6fb.svg";